import { render, staticRenderFns } from "./RequestFormView.vue?vue&type=template&id=0c4fd8b6&"
import script from "./RequestFormView.vue?vue&type=script&lang=ts&"
export * from "./RequestFormView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports